import { httpDelete, httpGet, httpPost } from '../utils'

export default {
  getList (cb, { page, perPage }) {
    httpGet(`/api/activity?page=${page}&per_page=${perPage}&order_by=updated_at`, cb)
  },
  getOne (cb, id) {
    httpGet(`/api/activity/${id}`, cb)
  },
  getFeedbackList (cb, { id, page, perPage, searchName, sessionTimeId }) {
    let url = `/api/activity/${id}/signup?order_by=created_at&page=${page}&per_page=${perPage}`
    if (searchName) {
      url += `&q=${searchName}`
    }
    if (sessionTimeId) {
      url += `&session_time_id=${sessionTimeId}`
    }
    httpGet(url, cb)
  },
  getFeedbackDetail (cb, { contactId, activityId, signupId }) {
    if (contactId) {
      httpGet(`/api/contact/${contactId}/activitysignup/${signupId}`, cb)
    } else {
      httpGet(`/api/activity/${activityId}/activitysignup/${signupId}`, cb)
    }
  },
  getShare (cb, id) {
    httpGet(`/api/share/activity/${id}`, cb)
  },
  postSingin (cb, { activityId, signUpId, body }) {
    httpPost(`/api/activity/${activityId}/signup/${signUpId}/signin`, body, cb)
  },
  postSingout (cb, { activityId, signUpId, body }) {
    httpPost(`/api/activity/${activityId}/signup/${signUpId}/signout`, body, cb)
  },
  getSignUp (cb, { activityId, number }) {
    httpGet(`/api/activity/${activityId}/activitysignup/number/${number}`, cb)
  },
  deleteSignIn (cb, { activityId, signUpId, signInId }) {
    httpDelete(`/api/activity/${activityId}/signup/${signUpId}/signin/${signInId}`, cb)
  },
  getActivityCount (cb, { activityId }) {
    httpGet(`api/activity/${activityId}/count`, cb)
  },
  getSigninStatistics (cb, { activityId, sessionTimeId }) {
    let url = `/api/activity/${activityId}/signin/statistics`
    if (sessionTimeId) {
      url += `?session_time_id=${sessionTimeId}`
    }
    httpGet(url, cb)
  }
}



// WEBPACK FOOTER //
// ./src/api/lxm/activity.js